




































import { Component, Vue, Prop } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';

@Component({
    components: {},
    computed: {
    }
})

export default class FileUpload extends AbpBase {
    @Prop({ type: File, default: null }) value: File;
    @Prop({ type: Number, default: null }) entity_id: number;
    @Prop({ type: String, default: 'sale' }) entity: string;
    @Prop({ type: String, default: '.txt' }) format: string;
    @Prop({ type: String, default: 'Importar' }) btnText: string;
    @Prop({ type: Number, default: 5 }) maxSize: number;
    name: string = 'file-upload';
    file: any = '';
    dragging: boolean = false;

    get loading() {
        return this.$store.state[this.entity].loading;
    }

    get formatText() {
        let text = this.format;
        if (this.format.indexOf('image/*') >= 0) {
            text = text.replace('image/*',',.jpg,.png,.jpge');
        }
        if (this.format.indexOf(',application/msword') >= 0) {
            text = text.replace(',application/msword', '');
        }
        if (this.format.indexOf(',application/vnd.openxmlformats-officedocument.wordprocessingml.document') >= 0) {
            text = text.replace(',application/vnd.openxmlformats-officedocument.wordprocessingml.document', '');
        }

        return text;
    }

    get formatExts() {
        let text = this.format;
        if (this.format.indexOf('image/*') >= 0) {
            text = text.replace('image/*', ',.jpg,.png,.jpge');
        }

        return text;
    }

    get extension() {
        return (this.file) ? this.file.name.split('.').pop() : '';
    }

    onChange(e) {
        var files = e.target.files || e.dataTransfer.files;

        if (!files.length) {
            this.dragging = false;
            return;
        }

        this.createFile(files[0]);
    }
    createFile(file) {
        let parts = file.name.split('.');
        let ext = '.' + parts[parts.length - 1];
        let format = this.formatExts.toLocaleLowerCase().split(',');
        if (format.indexOf(ext) < 0) {
            this.$toast.error('El formato no es valido', { timeout: 3000 });
            this.dragging = false;
            return;
        }

        if (this.maxSize != -1 && file.size > 5000000) {
            this.$toast.error('El tamano del archivo es mayor a  5 MB.', { timeout: 3000 });
            this.dragging = false;
            return;
        }

        this.file = file;
        this.dragging = false;
    }
    uploadFile() {
        this.$emit('input', this.file);
        this.$emit('upload-file', {
            file: this.file,
            entity_id: this.entity_id,
        });
    }
    removeFile() {
        this.file = '';
    }

    created() {

    }
}
